export enum FieldValue {
    DET = "Department of Economy and Tourism",
    ATTESTATION_DOCUMENT_TYPE_INV_COO = "Commercial Inv/Attach to COO",
    ATTESTATION_DOCUMENT_TYPE_INV_COO_AR = "فاتورة تجارية / مرفقة بشهادة م",
    INFORMATION_LETTER_TYPE_COO_BY_DC = "COO issued by Dubai Chamber",
    INFORMATION_LETTER_TYPE_COO_BY_DC_AR = "شهادة المنشأ صادرة عن غرفة دبي",
    COMPANY_PROFILE = "Company Profile",
    // COMPANY_PROFILE_AR = "ملف الشركة",
    COMPANY_PROFILE_AR = "بيانات منشأة",
    ATTESTATION_DOCUMENT_TYPE_OTHER = "Other",
    ATTESTATION_DOCUMENT_TYPE_OTHER_AR = "آحرون",
    UAE = "United Arab Emirates",
    UAE_AR = "الإمارات العربية المتحدة",
    INDIVIDUAL = "Individual",
    MYSELF = "Myself",
    MYSEL_AR = "Myself",
    COMPANY = "Company",
    FREE_ZONE = "Freezone",
    CHANEL_ONLINE_EN = "Online",
    CHANEL_ONLINE_AR = "الموقع الالكتروني",
    PAYMENT_METHOD_ONLINE_EN = "Online",
    PAYMENT_METHOD_ONLINE_AR = "عبر الانترنت", //new عبر الانترنت
    REENTRY_EN = "ReEntry",
    VISIT_EN = "Visit",
    TRANSIT_EN = "Transit",
    REENTRY_AR = "إعادة الدخول",
    VISIT_AR = "زيارة",
    TRANSIT_AR = "عبور",
    COURIER_EN = "Courier",
    COURIER_AR = "التوصيل",
    DCCI_BRANCH_EN = "DCCI Branch",
    DCCI_BRANCH_AR = "المكتب الرئيسي", //"فرع غرفة دبي للتجارة",
    OTHER_BANK = "Others",
    OTHER_BANK_AR = "آخرون",
    YES = "Yes",
    YES_AR = "نعم",
    NO = "No",
    NO_AR = "لا",
    LOCAL = "Local",
    LOCAL_AR = "محلي",
    FOREIGN = "Foreign",
    FOREIGN_AR = "أجنبي",
    ANIMALS = "Animals",
    ANIMALS_AR = "حيوان",
    VEHICLES = "Vehicles",
    VEHICLES_AR = "مركبة",
    USED_PRODUCTS = "Used Products",
    USED_PRODUCTS_AR = "المنتجات المستعملة",
    PROCESSING_TYPE_NORMAL = "Normal",
    PROCESSING_TYPE_NORMAL_AR = "غير المستعجل",
    DOCUMENT_PAYMENT_SLIP = "Payment Slip Proof",
    OFFSHORE_LICENSE = "Offshore License",
    OFFSHORE_LICENSE_AR = "رخصة  أفشور",
    WITHOUT_LICENSE = "Without License",
    WITHOUT_LICENSE_AR = "بدون رخصة",
    JOB_TITLE_MANAGER_AR = "مدير",
    PAYMENT_METHOD_ADVANCE_FOR_SERVICES = "Advance For Services",
    PAYMENT_METHOD_ADVANCE_FOR_SERVICES_AR = "خدمات مسبقة الدفع",
    FIRMT_TYPE_MAINOFFICE = "MAIN OFFICE",
    FIRMT_TYPE_MAINOFFICE_AR = "MAIN OFFICE", //"مركز رئيس",
    NOTE_TYPE_AGENT = "Note to Agent",
    NOTE_TYPE_AGENT_AR ="ملاحظة للموظف",
    PROFESSIONAL_LICENSE = "Professional License",
    SERVICE_LICENSE = "Service License",
    DIRECT_SHIPMENT = "Direct Shipment",
    DIRECT_SHIPMENT_AR = "شحن مباشر",
    INDUSTRIAL_LICENSE = "Industrial License",
    INDUSTRIAL_LICENSE_AR = "رخصة صناعية",
    INDUSTRIAL = "Industrial",
    INDUSTRIAL_AR = "رخصة صناعية",
    TRADER_LICENSE = "Trader License",
    TRADER_LICENSE_AR = "رخصة التاجر",
    TRADING_LICENSE = "Trading License",
    TRADING_LICENSE_AR = "رخصة التداول",
    TRADING = "Trading",
    TRADING_AR = "تجارة",
    FREE_MARKETING_CERTIFICATE = "Free Marketing Certificate.",
    FREE_MARKETING_CERTIFICATE_AR = " شهادة التسويق الحر",
    AUTHORIZED_SIGNATORY_CERTIFICATE = "Authorized Signatory Certificate",
    AUTHORIZED_SIGNATORY_CERTIFICATE_AR = "شهادة المفوض بالتوقيع",
    AMENDMENT_TRADE_NAME_CERTIFICATE = "Amendment Of The Trade Name Certificate",
    AUDITORS_REPORT = "Auditors Report",
    AUDITORS_REPORT_AR = "تقارير المحاسبة",
    LOCATION_OUTSIDE_FREEZONE ="Confirmation Of Company Location (OUTSIDE FREE ZONE)", //"Confirmation Of Company\u2019s Location (OUTSIDE FREE ZONE)",
    ENQUIRY_TYPE_CERTIFICATE_AMENDMENT = "Certificate Amendment",
    ENQUIRY_TYPE_CERTIFICATE_AMENDMENT_AR = "تعديل الشهادة",
    ENQUIRY_TYPE_WHOM_MAY_CONCERN = "To whom it may concern",
    ENQUIRY_TYPE_WHOM_MAY_CONCERN_AR = "إلي من يهمه الامر",
    LETTER_TYPE_OWNER_PARTNER = "Owner Partner Certificate",
    LETTER_TYPE_OWNER_PARTNER_AR = "شهادة المالك\\/المالكين \u2013 الشريك\\/الشركاء", //"شهادة المالك/المالكين \u2013 الشريك/الشركاء",
    User_COMPLAINANT_EN = "COMPLAINANT",
    User_COMPLAINANT_AR = "المدّعي",
    User_RESPONDENT_EN = "RESPONDENT",
    User_RESPONDENT_AR = "المدّعى عليه",
    CERTIFICATE_LANG_EN="English",
    CERTIFICATE_LANG_AR ="الإنجليزية"
}
export enum ServiceNameAr {
    MEMBERSHIP = "خدمات العضوية", // Membership Services
    MEMBERSHIP_NEW = "عضوية جديدة",
    MEMBERSHIP_AMENDMENT = "تعديل",
    MEMBERSHIP_RENEW = "تجديد",
    MEMBERSHIP_CANCELLATION = "إلغاء",
    MEMBERSHIP_MANAGEMENT_SIGNATORIES = "إدارة المفوضين بالتوقيع",

    INFORMATION_SERVICES = "خدمات المعلومات", // Information Services
    INFORMATION_AND_CERTIFICATES_SERVICES = "خدمة المعلومات والشهادات", // Information and Certificates Services
    MEDIATION_SERVICES = "الخدمات القانونية", // Mediation Services
    MEDIATION = "الوساطة",

    SIGNATURE_OF_VERIFICATION = "صحة التواقيع",
    ATTESTATION_AUTH_CERTIFICATE = "مصادقة الشهادة",
    ATTESTATION_CERTIFY_DOCUMENT = "صورة طبق الأصل",
    ATTESTATION_VERIFY_SIGNATURE = "التحقق من التوقيع",
    ATTESTATION = "التصديق",
    ATTESTATION_AUTH_CERTIFICATE_DISPLAY = "خدمات التوثيق",
    ATTESTATION_CERTIFY_DOCUMENT_DISPLAY = "صورة طبق الأصل",
    ATTESTATION_VERIFY_SIGNATURE_DISPLAY = "صحة التوقيع",

    ATA_CARNET = "دفتر الادخال المؤقت", // ATA Carnet
    ISSUE_NEW_CARNET = "انشاء دفتر جديد",
    AMENDMENT_CARNET = "تعديل الدفتر",
    REPLACE_CARNET = "الدفتر البديل",
    SUBSTITUTE_CARNET = "دفتر بدل فاقد",
    REFUND_CARNET = "استرداد",
    NOC_LETTER_CARNET = "طلب خطاب عدم ممانعة",

    PAYMENT_SERVICES = "خدمات الدفع", // Payment Services
    PAYMENT_ADVANCE_FOR_SERVICES = "استقطاع من الرصيد",

    COO = "شهادة المنشأ", // Certificate Of Origin
    ISSUE_NEW_COO = "إصدار شهادة منشأ جديدة",
    COO_BULK_UPLOAD = "تحميل مجموعات شهادات المنشأ",
    AMENDMENT_COO = "تعديل",
    PERSONAL_EFFECTS_COO = "الأمتعة الشخصية",
    ISSUE_GSP_COO = "إصدار شهادة GSP",

    USER_MANAGEMENT = "إدارة المستخدم",
    USER_ACCESS = "صلاحيات المستخدم", //"وصول المستخدم",
    UNLINK_ACCESS = "Unlink Access",
    SERVICE_EXCELLENCE_PROGRAMME = "برنامج الخدمة المتميزة",
    MYSTERY_SHOPPER_MEMBERSHIP = "عضوية المتسوق السرّي",
    MRM_AWARDS = "جائزة محمد بن راشد آل مكتوم لل",
    MRM_APPLICATION = "طلب التقديم على الجائزة", //"ورشة عمل تدريبية للجائزة",
    MRM_TRAINING_WORKSHOP = "ورشة عمل تدريبية للجائزة",
    CHAMBER_ENTREPRENEURS= "رواد الأعمال في الغرفة التجاري",
    New_User="New User",
    VENUE_BOOKING= "حجز القاعات"
}
export enum ServiceNameEn {
    MEMBERSHIP = "Membership Services",
    MEMBERSHIP_NEW = "New Membership",
    MEMBERSHIP_AMENDMENT = "Amendment",
    MEMBERSHIP_RENEW = "Renew",
    MEMBERSHIP_CANCELLATION = "Cancellation",
    MEMBERSHIP_MANAGEMENT_SIGNATORIES = "Manage Signatories",


    INFORMATION_SERVICES = "Information Services",
    INFORMATION_AND_CERTIFICATES_SERVICES="Information and Certificates Services",
    MEDIATION_SERVICES = "Mediation Services",
    MEDIATION = "Mediation",
    SIGNATURE_OF_VERIFICATION = "Signature Of Verification",
    ATTESTATION_AUTH_CERTIFICATE = "Authenticate Certificate",
    ATTESTATION_CERTIFY_DOCUMENT = "True Copy",
    ATTESTATION_VERIFY_SIGNATURE = "Verify Signature",
    ATTESTATION = "Attestation",
    ATTESTATION_AUTH_CERTIFICATE_DISPLAY = "Authentication",
    ATTESTATION_CERTIFY_DOCUMENT_DISPLAY = "True Copy",
    ATTESTATION_VERIFY_SIGNATURE_DISPLAY = "Signature Verification",

    ATA_CARNET = "ATA Carnet",
    ISSUE_NEW_CARNET = "Issue New Carnet",
    AMENDMENT_CARNET = "Amendment Carnet",
    REPLACE_CARNET = "Replacement Carnet",
    SUBSTITUTE_CARNET = "Substitute Carnet",
    REFUND_CARNET = "Refund",
    NOC_LETTER_CARNET = "NOC Letter Request",

    PAYMENT_SERVICES = "Payment Services",
    PAYMENT_ADVANCE_FOR_SERVICES = "Advance For Services",

    COO = "Certificate Of Origin",
    ISSUE_NEW_COO = "Issue New COO",
    COO_BULK_UPLOAD = "COO Bulk Upload",
    AMENDMENT_COO = "Amendment",
    PERSONAL_EFFECTS_COO = "Personal Effects",
    ISSUE_GSP_COO = "Issue GSP Certificate",
    USER_MANAGEMENT = "User Management",
    USER_ACCESS = "User Access",
    UNLINK_ACCESS = "Unlink Access",

    SERVICE_EXCELLENCE_PROGRAMME = "Service Excellence Programme",
    MYSTERY_SHOPPER_MEMBERSHIP = "Mystery Shopper Membership",

    MRM_AWARDS = "MRM Awards",
    MRM_APPLICATION = "MRM Application",
    MRM_TRAINING_WORKSHOP = "MRM Training Workshop",
    CHAMBER_ENTREPRENEURS= "Chamber Entrepreneurs",
    VENUE_BOOKING= "Venue Booking",
    New_User="New User"
}
export enum UserType {
    MEMBER = "Member",
    MEMBER_AR = "عضو",
    NON_MEMBER = "Non Member",
    NON_MEMBER_AR = "غير الأعضاء",
}

export enum SrActionType {
    SAVE = "Save",
    DRAFT = "Draft",
    SUBMIT = "Submit"
}

export enum SrIOName {
    MEMBERSHIP = "DCMemSRIO",
    MEDIATION = "DCMemSRIO",//"DCMediationWebIO",
    INFORMATION_SERVICE = "DCMemSRIO", //"DC SR Info Service IO", //"DC SR Information Service"
    ATTESTATION = "DCCreateSVSIO",
    ISSUE_NEW_ATA_CARNET = "DC Community Portal SR IO",
    CREATE_PAYMENT = "DCCreatePaymntSRIO",
    COO_CREATE = "DCCOOMOBILE",
    LINK_MEMBER = "DC Community Portal SR Upsert IO",
    DCDCEIO="DCDCEIO"
}
export enum DocumentServiceType {
    MEMBERSHIP_WALLET = "MEM",
    MEMBERSHIP_SIGNATURE_FORMS = "S_FORMS",
    MEMBERSHIP = "MEM_COM",
    MEMBERSHIP_WITHOUT_LIC = "WITHOUTLIC",
    MEMBERSHIP_OFLIC = "OFLIC",
    MANAGE_SIG = "MANAGE_SIG",
    MEM_CANCEL = "MEM_CANCEL",
    INFORMATION_SERVICE = "IS",
    MEDIATION = "LS",
    COO = "CS",
    COO_GSP = "CS",
    COO_PERSONAL = "COOPE",
    ATTESTATION = "SVS",
    ATA_CARNET = "ATA",
    ATA_NOC = "ATANOC",
    ATA_REFUND = "ATAR",
    BUSINESS_GROUP = "BC",
    LIC_CATG_FZ = "FZ",
    LIC_CATG_NFZ = "NFZ",
    MED_CASE = "MED_CASE",
    PS = "PS",
    ENTPR = "ENTPR",
    VENB = "VENB",
    UM_NU="UM_NU",
    UM_UA="UM_UA"
}
// --- Proxy wrapper ---
type Lang = "en" | "ar";
// This method is used to get lang
function getLang(): Lang {
    return (localStorage.getItem("selectedLang") as Lang) || "en";
}

export const ServiceName = new Proxy(ServiceNameEn, {
    // This method is used to get using  and prop
    get(_, prop: string) {
        const lang = getLang();
        if (lang === "ar") {
            return (ServiceNameAr as any)[prop];
        }
        return (ServiceNameEn as any)[prop];
    }
});

export const ACCESS_SERVICE_FLAG_MAPPING: Record<string, string> = {
    'DC Membership Services Flag': 'Membership Services',
    'DC COO Services Flag': 'Certificate Of Origin',
    'DC SVS Services Flag': 'Signature Verification',
    'DC Legal Services Flag': 'Mediation Services',
    'DC Information Services Flag': 'Information and Certificates Services',
    'DC Payment Services Flag': 'Payment Services',
    "DC ATA Carnet Flag": "ATA Carnet"
};

export interface ServiceItem {
    label: string;
    checked: boolean;
}

export function mapServicesFromFlags(
    accessDetails: Record<string, any>
): ServiceItem[] {
    return Object.keys(ACCESS_SERVICE_FLAG_MAPPING).map(flagKey => ({
        label: ACCESS_SERVICE_FLAG_MAPPING[flagKey],
        checked: accessDetails?.[flagKey] === 'Y'
    }));
}